import(/* webpackMode: "eager" */ "/vercel/path0/src/app/individual/page.tsx");
